<template>
  <div>
    <CCard>
      <CCardHeader>
        <div><h4>Selección de Periodo</h4></div>
        <CRow>
          <CCol>
            <CRow>
              <CCol md="1">
                <span slot="checkbox">
                  <CSwitch
                    width="150px"
                    class="mx-1 align-middle mb-2"
                    color="success"
                    shape="pill"
                    variant="outline"
                    v-bind="{ labelOn: '\u2713', labelOff: '\u2715' }"
                    v-c-tooltip.hover="{
                      content: 'Selección del Periodo Actual',
                      placement: 'left',
                    }"
                    :checked="selectPeriodoActual"
                    @update:checked="
                      selectPeriodoActual = !selectPeriodoActual;
                      ultimoperiodo();
                    "
                  />
                </span>
              </CCol>
              <CCol md="2">
                <multiselect
                  class="m-0 d-inline-block mb-2"
                  v-model="periodoSelected"
                  deselect-label=""
                  label="nombrePeriodo"
                  placeholder="Año"
                  select-label=""
                  selectedLabel=""
                  :custom-label="customNamePeriodo"
                  :options="periodos"
                  :searchable="true"
                  :loading="isLoadingPeriodos"
                  :disabled="selectPeriodoActual"
                  @select="refreshperiodo"
                >
                </multiselect>
              </CCol>
              <CCol md="2">
                <multiselect
                  class="m-0 d-inline-block mb-2"
                  v-model="mesSelected"
                  deselect-label=""
                  label="nombreMes"
                  placeholder="Mes"
                  select-label=""
                  selectedLabel=""
                  :options="periodoSelected == null ? [] : periodoSelected.meses"
                  :searchable="true"
                  :loading="isLoadingMes"
                  @select="refreshmes"
                  :disabled="periodoSelected == null || selectPeriodoActual"
                >
                </multiselect>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="3">
                <multiselect
                  class="m-0 d-inline-block mb-2 float-left"
                  select-label=""
                  selectedLabel=""
                  deselect-label=""
                  label="nombreDocumento"
                  v-model="seltipodoc"
                  :options="tipodoc"
                  placeholder="Tipo de Documento"
                  @select="obtenerEmpresa"
                  :disabled="periodoSelected == null || mesSelected == null || selectPeriodoActual
                  "
                >
                </multiselect>
              </CCol>
              <CCol md="6">
                <multiselect
                  class="m-0 d-inline-block mb-2 float-left"
                  select-label=""
                  selectedLabel=""
                  deselect-label=""
                  :hideSelected="false"
                  :custom-label="nomcod"
                  v-model="selempresa"
                  :options="empresas"
                  placeholder="Empresa"
                  @select="obtenerTrabajadores"
                  :disabled="seltipodoc == null"
                  :loading="isLoadingEmpresas"
                >
                <template slot="option" slot-scope="empresa">
                   <CBadge
                        class="m-1"
                        style="font-size:0.7rem; font-weight: normal;"
                        :color="(empresa.option.estado==1)?'info':(empresa.option.estado==2)?'danger':(empresa.option.estado==3)?'success':'secondary'"
                        v-c-tooltip.hover="{
                            content: (empresa.option.estado==1)?'En Revisón':(empresa.option.estado==2)?'Rechazado '+ empresa.option.mensajeRespuesta+' ('+(empresa.option.fechaMensaje)+')':(empresa.option.estado==3)?'Aceptado':'Sin Enviar',
                            placement:'right'
                        }">
                        <CIcon v-if="empresa.option.estado==1" style="width:20px; height:20px;" :content="$options.freeSet.cilArrowCircleRight" />
                        <CIcon v-else-if="empresa.option.estado==2" style="width:20px; height:20px;" :content="$options.freeSet.cilXCircle" />
                        <CIcon v-else-if="empresa.option.estado==3" style="width:20px; height:20px;" :content="$options.freeSet.cilCheckCircle" />
                        <CIcon v-else style="width:20px; height:20px;" :content="$options.freeSet.cilBan" />
                    </CBadge>
                  ({{empresa.option.codEmpresa}}) {{empresa.option.nombreEmpresa}}
                   

                </template>
                <template slot="singleLabel" slot-scope="empresa">
                    <CBadge
                        class="m-1"
                        style="font-size:0.7rem; font-weight: normal;"
                        :color="(empresa.option.estado==1)?'info':(empresa.option.estado==2)?'danger':(empresa.option.estado==3)?'success':'secondary'"
                        v-c-tooltip.hover="{
                            content: (empresa.option.estado==1)?'En Revisón':(empresa.option.estado==2)?'Rechazado '+ empresa.option.mensajeRespuesta+' ('+(empresa.option.fechaMensaje)+')':(empresa.option.estado==3)?'Aceptado':'Sin Enviar',
                            placement:'right'
                        }">
                        <CIcon v-if="empresa.option.estado==1" style="width:20px; height:20px;" :content="$options.freeSet.cilArrowCircleRight" />
                        <CIcon v-else-if="empresa.option.estado==2" style="width:20px; height:20px;" :content="$options.freeSet.cilXCircle" />
                        <CIcon v-else-if="empresa.option.estado==3" style="width:20px; height:20px;" :content="$options.freeSet.cilCheckCircle" />
                        <CIcon v-else style="width:20px; height:20px;" :content="$options.freeSet.cilBan" />
                    </CBadge>
                    ({{empresa.option.codEmpresa}}) {{empresa.option.nombreEmpresa}}
                    
                    <!--<CBadge
                      v-show="empresa.option != null"
                      class="m-1"
                      style="font-size:0.7rem; font-weight: normal;"
                      :color="empresa.option != null?((empresa.option.estado==1)?'info':(empresa.option.estado==2)?'danger':(empresa.option.estado==3)?'success':'secondary'):'secondary'"
                      v-c-tooltip.hover="{
                          content: empresa.option != null?((empresa.option.estado==1)?'En Revisón':(empresa.option.estado==2)?'Rechazado '+ empresa.option.mensajeRespuesta+' ('+getDate(empresa.option.fechaMensaje)+')':(empresa.option.estado==3)?'Aceptado':'Sin Enviar'):'Sin Empresa Seleccionada',
                          placement:'left'
                      }">
                      <CIcon v-if="empresa == null" style="width:20px; height:20px;" :content="$options.freeSet.cilBan" />
                      <CIcon v-else-if="empresa.option.estado==1" style="width:20px; height:20px;" :content="$options.freeSet.cilArrowCircleRight" />
                      <CIcon v-else-if="empresa.option.estado==2" style="width:20px; height:20px;" :content="$options.freeSet.cilXCircle" />
                      <CIcon v-else-if="empresa.option.estado==3" style="width:20px; height:20px;" :content="$options.freeSet.cilCheckCircle" />
                      <CIcon v-else style="width:20px; height:20px;" :content="$options.freeSet.cilBan" />
                  </CBadge>-->
                </template>
                </multiselect>
                
                <!--<CBadge
                  v-show="selempresa != null"
                    class="m-1"
                    style="font-size:0.7rem; font-weight: normal;"
                    v-c-tooltip.hover="{
                        content: (selempresa != null?selempresa.estado==1:false)?'En Revisón':(selempresa != null?selempresa.estado==2:false)?'Rechazado '+ selempresa.mensajeRespuesta+' ('+getDate(selempresa.fechaMensaje)+')':(selempresa != null?selempresa.estado==3:false)?'Aceptado':'Sin Enviar',
                        placement:'left'
                    }"
                    shape="pill" :color="(selempresa.estado==1)?'info':(selempresa.estado==2)?'danger':(selempresa.estado==3)?'success':'secondary'">
                    <CIcon v-if="selempresa != null?selempresa.estado==1: false" style="width:20px; height:20px;" :content="$options.freeSet.cilArrowCircleRight" />
                    <CIcon v-else-if="selempresa != null?selempresa.estado==2: false" style="width:20px; height:20px;" :content="$options.freeSet.cilXCircle" />
                    <CIcon v-else-if="selempresa != null?selempresa.estado==3: false" style="width:20px; height:20px;" :content="$options.freeSet.cilCheckCircle" />
                    <CIcon v-else style="width:20px; height:20px;" :content="$options.freeSet.cilBan" />

                </CBadge>-->
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <!--<CCol md="1">
            <span slot="checkbox">
              <CSwitch
                width="150px"
                class="mx-1 align-middle mb-2"
                color="success"
                shape="pill"
                variant="outline"
                v-show="trabajadores.length > 1"
                v-bind="{ labelOn: '\u2713', labelOff: '\u2715' }"
                v-c-tooltip.hover="{
                  content: 'Marcar/Desmarcar Todos',
                  placement: 'left',
                }"
                :checked="marcado"
                @update:checked="
                  marcado = !marcado;
                  marcdes(marcado);
                "
              />
            </span>
          </CCol>
          <CCol md="8" aria-placeholder="left">
            <span v-show="trabajadores.length > 1"
              ><h6>
                {{ marcado ? "Desmarcar" : "Marcar" }} a todos los trabajadores
                dentro de la tabla
              </h6></span
            >
          </CCol>-->
          <CCol md="5" aria-placeholder="left">
            <CButton
                v-show="(selempresa != null)?selempresa.hayTrabajadoresParaEnviar:false"
                v-c-tooltip.hover="{content:'Enviar Todos los documentos a sus trabajadores', placement:'left'}" 
                style="font-size:11px;"
                class="btnPrincipalVapp m-1"
                :disabled="isLoadingEnvioTodos"
                @click="enviaraTodos"
              >
              <CIcon v-show="isLoadingEnvioTodos" :content="$options.freeSet.cilLoopCircular" class="imgr" />
                {{txtEnviarTodos}}
              </CButton>
              <CButton
                  class="btnPrincipalVapp m-1"
                  style="font-size:11px;"
                  v-show="(selempresa!=null)?selempresa.hayDocumentosTrabajador:false"
                  @click="tripleDialog = true"
                >
                  Descargar Documentos
                </CButton>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <multiselect
              class="mt-2 mb-2"
              :id="(selempresa != null)?selempresa:'sinEmpresa'"
              v-model="trabajadoresSelectedFiltro" 
              :custom-label="customTrabajador" 
              select-label=""
              selectedLabel=""
              deselect-label=""
              track-by="nombreTrabajador" 
              placeholder="Buscar Trabajador" 
              open-direction="bottom" 
              :options="trabajadoresFiltro" 
              :multiple="true" 
              :searchable="true"
              :loading="isLoadingTrabajadoresFiltros" 
              :internal-search="false" 
              @search-change="asyncFind"
              @select="filTrab"
              @remove="rmvTrabSel">
              <template slot="afterList">
                  <div v-observe-visibility="(isVisible, entry) => !isLoadingTrabajadoresFiltros?reachedEndOfList(isVisible, entry, selempresa):''" v-if="hasNextPage(selempresa)" />
              </template>
              <span slot="noResult">No se han encontrado trabajadores con esos datos</span>
          </multiselect>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <a-table
              :columns="columns"
              :data-source="trabajadores"
              :pagination="paginacion"
              :scroll="{ x: 810, y: 270 }"
              class="components-table-demo-nested m-1"
              size="small"
              style="overflow: auto"
              :loading="isLoadingTrabajadores"
              @change="handleTableChange"
            >
              <span slot="envioCorreo" slot-scope="trabajador">
                <CIcon
                  v-show="!trabajador.documento.hayDocumento"
                  v-c-tooltip.hover="{
                    content: trabajador.documento.nombreDocumento,
                    placement: 'left',
                  }"
                  :content="$options.freeSet.cilMeh"
                />
                <CIcon
                  class="ml-2"
                  style="color:#e55353"
                  v-show="trabajador.documento.hayDocumento && !trabajador.tieneMailTrabajador && !trabajador.modificarMail"
                  v-c-tooltip.hover="{content:'El trabajador no tiene correo', placement:'left'}" 
                  :content="$options.freeSet.cilWarning"
                /> 
                <CIcon
                  class="ml-2"
                  style="color:#f9b115"
                  v-show="trabajador.documento.hayDocumento && trabajador.documento.estadoDocumento != 3 && !trabajador.modificarMail"
                  v-c-tooltip.hover="{content:'El documento no está aceptado', placement:'left'}" 
                  :content="$options.freeSet.cilWarning"
                />

                <CButton
                  v-c-tooltip.hover="{content:`Este documento ya a sido enviado al trabajador ${formatFechaDocumento(trabajador.documento.fechaEnvioATrabajador)}, volver a enviar`, placement:'left'}" 
                  style="font-size:11px;"
                  class="btnPrincipalVapp"
                  :disabled="trabajador.documento.estadoDocumento != '3' || !trabajador.tieneMailTrabajador"
                  v-show="trabajador.documento.hayDocumento && trabajador.documento.enviadoTrabajador && !trabajador.documento.isLoadiongEnvio && !trabajador.modificarMail"
                  @click="enviarDocumentoTrabajador(trabajador)">
                  <CIcon :content="$options.freeSet.cilEnvelopeOpen"  />
                  <CIcon :content="$options.freeSet.cilExpandRight"  />
                  
                </CButton>
                

                <CButton
                  v-c-tooltip.hover="{content:(trabajador.documento.estadoDocumento != 3)?'El documento debe estar aceptado':'Documento listo para enviar a trabajador', placement:'left'}" 
                  style="font-size:11px;"
                  class="btnPrincipalVapp"
                  :disabled="trabajador.documento.estadoDocumento != 3 || !trabajador.tieneMailTrabajador"
                  v-show="trabajador.documento.hayDocumento && !trabajador.documento.enviadoTrabajador && !trabajador.documento.isLoadiongEnvio && !trabajador.modificarMail"
                  @click="enviarDocumentoTrabajador(trabajador)"
                >
                  Enviar a trabajador
                </CButton>
                
                <CButton
                  style="font-size:11px;"
                  class="btnNormalVapp2"
                  v-show="trabajador.documento.isLoadiongEnvio"
                  >
                  <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" /> enviando
                </CButton>
                
                

                  <CButton
                    style="font-size:11px;"
                    class="btnNormalVapp2"
                    v-show="trabajador.isModificandoMail"
                    >
                    <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" /> Modificando
                  </CButton>

                  <CInput
                      v-model="trabajador.mailModificado"
                      type="text"
                      horizontal
                      placeholder="Correo"
                      :is-valid="trabajador.mailValido"
                      v-show="trabajador.modificarMail && !trabajador.isModificandoMail"
                      @keyup="validarMail(trabajador)">
                      <template #append>
                      <CButton 
                        color="success" 
                        size="sm"
                        :disabled="!trabajador.mailValido"
                        @click="cambiarCorreoTrabajador(trabajador)"
                        v-c-tooltip.hover="{
                          content:'Guardar Correo', 
                          placement:'left'
                        }">
                          <CIcon name="cil-check-circle"/>
                      </CButton>

                      <CButton
                        v-c-tooltip.hover="{
                          content:(trabajador.modificarMail)?'Cancelar':'Modificar Correo', 
                          placement:'left'
                        }"
                        v-show="trabajador.modificarMail"
                        color="danger" 
                        @click="trabajador.modificarMail = false" size="sm" ><CIcon name="cil-x-circle"/>
                      </CButton>
                    </template>
                  </CInput>
                <!--
                

                

                  -->
                  
                  
                <!--</CButtonToolbar>-->
                  
                  <CButtonGroup size="sm" class="mx-1"
                    v-show="!trabajador.tieneMailTrabajador && !trabajador.modificarMail"
                        v-c-tooltip.hover="{
                          content:(trabajador.modificarMail)?'Cancelar':'Modificar Correo', 
                          placement:'left'
                        }">
                      
                      <CButton 
                        color="warning" size="sm"
                        @click="trabajador.modificarMail = true"
                      >
                          <CIcon name="cil-pencil"/>
                      </CButton>
                  </CButtonGroup>
                
              </span>
              <!--<span slot="checkbox" slot-scope="trabajador">
                <CSwitch
                  width="3px"
                  class="mx-1 align-middle"
                  color="success"
                  shape="pill"
                  variant="outline"
                  v-bind="{ labelOn: '\u2713', labelOff: '\u2715' }"
                  :checked="trabajador.chek"
                  @update:checked="trabajador.chek = !trabajador.chek"
                />
              </span>-->
              <span slot="rut" slot-scope="rut">{{ rut }}</span>
              <span slot="nombre" slot-scope="nombre">{{ nombre }}</span>
              <span slot="documento" slot-scope="trabajador">
                <a
                  v-if="trabajador.documento.hayDocumento"
                  :href="trabajador.documento.urlDocumento"
                  target="_blank"
                  style="text-decoration: none"
                  class="mr-4"
                  v-c-tooltip.hover="{
                    content: 'Descargar Documento',
                    placement: 'left',
                  }"
                >
                  <CIcon
                    v-if="trabajador.documento.hayDocumento == true"
                    :content="$options.freeSet.cilCloudDownload"
                  />
                </a>
                <a
                  v-if="trabajador.documento.hayDocumento"
                  style="text-decoration: none"
                  class="ml-4"
                  @click="abrirVisor(trabajador)"
                  v-c-tooltip.hover="{
                    content: 'Ver Documento',
                    placement: 'right',
                  }"
                >
                  <CIcon
                    v-if="trabajador.documento.hayDocumento == true"
                    :content="$options.freeSet.cilZoomIn"
                  />
                </a>

                <CIcon
                  v-else
                  v-c-tooltip.hover="{
                    content: trabajador.documento.nombreDocumento,
                    placement: 'left',
                  }"
                  :content="$options.freeSet.cilMeh"
                />
              </span>

              <span slot="gen" slot-scope="trabajador">
                <CRow v-if="trabajador.documento.hayDocumento">
                  <CCol sm="12">
                    {{
                      formatFechaDocumento(
                        trabajador.documento.ultimaGeneracion
                      )
                    }}
                  </CCol>
                </CRow>
              </span>

              <span slot="estadoDocumento" slot-scope="trabajador">
                <CBadge
                  shape="pill"
                  :color="
                    trabajador.documento.estadoDocumento == 1
                      ? 'info'
                      : trabajador.documento.estadoDocumento == 2
                      ? 'danger'
                      : trabajador.documento.estadoDocumento == 3
                      ? 'success'
                      : 'secondary'
                  "
                >
                  {{
                    trabajador.documento.hayDocumento
                      ? trabajador.documento.estadoDocumento == 1
                        ? "En Proceso"
                        : trabajador.documento.estadoDocumento == 2
                        ? "Rechazado"
                        : trabajador.documento.estadoDocumento == 3
                        ? "Aceptado"
                        : "Sin Enviar"
                      : "Sin Documento"
                  }}
                </CBadge>
              </span>
            </a-table>
          </CCol>
        </CRow>
        <!--<CRow v-show="trabajadores.length > 0">
          <CCol>
            <span
              ><h6>
                {{
                  selempresa
                    ? selempresa.nombreEmpresa
                    : "NO ha seleccionado empresa"
                }}
                se encuentra {{ estado }}
              </h6></span
            >
          </CCol>
        </CRow>-->
        <CRow v-show="estadosDocumentos.length >0">
          
        </CRow>
      </CCardBody>
      <CCardFooter>
        <CRow>
          <CCol md="4">
            <CRow>
              <CCol md="6">
                
              </CCol>
            </CRow>
            <CRow>
              <CCol md="6">
                  <!--<div v-show="this.visboton == 0">
                    Modificadores del estado actual de la empresa que se encuentra
                    En Revisión, ya sea para Rechazarla o Aceptar los documentos
                    presentados en la tabla.
                  </div>-->
                  <CButton
                    md="3"
                    class="btnPrincipalVapp float-left m-3"
                    style="margin: 10%"
                    @click="simpleDialog = true"
                    v-show="this.visboton == 0"
                  >
                    <strong> Rechazar </strong>
                  </CButton>
                  <CButton
                    md="3"
                    class="btnPrincipalVapp float-left m-3"
                    style="margin: 10%"
                    :disabled="estadosDocumentos.length > 0"
                    @click="doubleDialog = true"
                    v-show="this.visboton == 0"
                  >
                    <strong> Aceptar </strong>
                  </CButton>
                </CCol>
            </CRow>
          </CCol>
            <CCol md="5" v-show="estadosDocumentos.length >0">
            <CAlert show color="warning">
              <h4 class="alert-heading">Ha rechazado {{estadosDocumentos.length}} Documento{{estadosDocumentos.length>1?'s':''}}</h4>
              <p>
                Estos documentos no han sido notificados aún, para que sean notificados debe rechazar la empresa en cuestión le recomedamos realizar esta acción
              </p>
              <hr>
              <p class="mb-0">
                En el caso de que necesite quitar uno a más documentos rechazados ingrese al visor de documentos(icono de lupa en la tabla) y quite el documento de los rechazados.
              </p>
            </CAlert>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>
    <ModalPdfView
      :prevue="prevue"
      :trabajadores="trabajadores"
      :trabajadorprev="trabajadorprev"
      :portalCliente="this"
    />

    <Modal
      v-model="tripleDialog"
      :title="'Descarga de ' + (seltipodoc == null ? '' : seltipodoc.nombreDocumento)"
    >
      <h6>Descargar archivos cómo:</h6>
      <span>
        <input type="radio" id="Zip" value="zip" v-model="picked" />
        <label for="Zip" class="ml-1"> Zip</label>
        <br />
        <input type="radio" id="ArchivoUnico" value="merge" v-model="picked" />
        <label for="ArchivoUnico" class="ml-1"> Archivo Unico en PDF</label>
        <br />
        <div>Su descarga {{(selempresa!=null)?(selempresa.trabajadoresFiltrados.length>0)?'de trabajadores seleccionados': '':''}} comenzará al Aceptar.</div>
      </span>
      <br />
      <div>
        <CIcon v-show="isdownload" :content="$options.freeSet.cilLoopCircular" class="imgr" /> {{ auxi }}
      </div>
      <div v-show="generadoDocumentoDescarga">
        Si la descarga no inicia automaticamente descárguelo aquí
        <a id="documentoDescarga" 
          class="ml-1"
          :href="linkDocumentoDescarga" target="_blank"
          style="text-decoration: none; color:#0b7689;" 
          v-c-tooltip.hover="{content:'Descargar Documento', placement:'rigth'}">
          <CIcon :content="$options.freeSet.cilCloudDownload" /> 
      </a>
      </div>

      <CButton
        md="3"
        class="btnPrincipalVapp m-3 align-right"
        style="margin: 20%"
        id="descargar"
        @click="
          onClick();
          tripleDialog = true;
        "
        :disabled="isdownload"
        >Aceptar</CButton
      >
      <CButton
        md="3"
        class="btnPrincipalVapp m-3"
        style="margin: 20%"
        @click="closeModalDescarga(); tripleDialog = false"
        >Cancelar</CButton
      >
    </Modal>

    <Modal
      v-model="simpleDialog"
      :title="
        'Rechazo de ' + (seltipodoc == null ? '' : seltipodoc.nombreDocumento)
      "
    >
      <div>
        <h6>Favor redacte la razon del rechazo para los documentos.</h6>
      </div>
      <div>
        <CTextarea
          placeholder="Razon..."
          horizontal
          rows="6"
          v-model="message"
          @keydown="check"
        />
        <p :class="{ help: true, 'is-danger': limit - message.length == 0 }">
          {{ message.length }}/{{ limit }}
        </p>
      </div>
      <div>
        <h6>
          ¿Está de acuerdo en rechazar la informacion presentada en los
          documentos?
        </h6>
      </div>
      <CButton
        md="3"
        class="btnPrincipalVapp m-3 align-right"
        style="margin: 20%"
        @click="
          rechazar();
          simpleDialog = false;
        "
        >Aceptar</CButton
      >
      <CButton
        md="3"
        class="btnPrincipalVapp m-3"
        style="margin: 20%"
        @click="simpleDialog = false"
        >Cancelar</CButton
      >
    </Modal>

    <Modal
      v-model="doubleDialog"
      :title="'Validación de ' + (seltipodoc == null ? '' : seltipodoc.nombreDocumento)"
    >
      <div><h6>Verifique que todo está correcto antes de continuar.</h6></div>
      <div>
        <h6>
          Al hacer click en Aceptar, se le notificara al encargado acerca del
          estado actual de los documentos.
        </h6>
      </div>
      <div>
        <h6>
          ¿Está de acuerdo con la informacion presentada en los documentos?
        </h6>
      </div>
      <CButton
        md="3"
        class="btnPrincipalVapp m-3 align-right"
        style="margin: 20%"
        @click="
          aceptar();
          doubleDialog = false;
        "
        >Aceptar</CButton
      >
      <CButton
        md="3"
        class="btnPrincipalVapp m-3"
        style="margin: 20%"
        @click="doubleDialog = false"
        >Cancelar</CButton
      >
    </Modal>
  </div>
</template>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import cons from "@/const";
import axios from "axios";
import Multiselect from "vue-multiselect";
import qs from "qs";

import VueModal from "@kouts/vue-modal";
import "@kouts/vue-modal/dist/vue-modal.css";

import { freeSet } from "@coreui/icons";

import ModalPdfView from "./componentes/ModalPdfView";

import { format, formatDistance, formatRelative, subDays } from "date-fns";
import es from "date-fns/locale/es";
window.locale = "es";

export default {
  name: "PortalCliente",
  freeSet,
  components: {
    Multiselect,
    Modal: VueModal,
    ModalPdfView,
  },

  data() {
    return {
      tokenLogin: JSON.parse(this.$cookie.get("userLogginToken")).tokenUsuario,

      regMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                
      paginacion: {pageSize: 10},

      limit: 365,
      message: "",
      picked: "",
      link: "",
      isdownload: false,
      anno: null,
      mes: null,
      marcado: true,
      prev: "",

      desmodal: false,
      largo: 0,
      estadosDocumentos: [],

      isLoadingPeriodos: false,
      isLoadingMes: false,
      isLoadingTrabajadores: false,
      selectPeriodoActual: false,
      isLoadingEmpresas: false,
      isLoadingEnvioTodos: false,

      txtEnviarTodos: "Enviar mail a todos",

      periodoSelected: null,
      mesSelected: null,
      selempresa: null,
      seltipodoc: null,
      estado: "",
      visboton: null,
      trabajadorprev: {},

      simpleDialog: false,
      doubleDialog: false,
      tripleDialog: false,
      prevue: false,

      empresas: [],
      periodos: [],
      tipodoc: [],
      trabajadores: [],

      descargas: [],
      auxi: "",

      rqstEmps: null,

      columns: [
        /*{
          title: "Check",
          scopedSlots: { customRender: "checkbox" },
          width: "5%",
        },*/
        {
          title: "Rut Trabajador",
          dataIndex: "rutTrabajador",
          scopedSlots: { customRender: "rut" },
          key: "rutTrabajador",
          width: "10%",
        },
        {
          title: "Nombre",
          dataIndex: "nombreTrabajador",
          scopedSlots: { customRender: "nombre" },
          width: "20%",
        },
        {
          title: "Documento",
          scopedSlots: { customRender: "documento" },
          width: "15%",
          align: "center",
        },
        {
          title: "Última Generación",
          scopedSlots: { customRender: "gen" },
          width: "15%",
          align: "center",
        },
        {
          title: "Estado Documento",
          scopedSlots: { customRender: "estadoDocumento" },
          width: "10%",
          align: "center",
          ellipsis: true,
        },
        {
          title: "Enviar Documento",
          scopedSlots: { customRender: 'envioCorreo' },
          width: "20%",
          align: "center"
        }
      ],
      trabajadoresSelectedFiltro: null,
      trabajadoresFiltro: [],
      isLoadingTrabajadoresFiltros: false,

      generadoDocumentoDescarga: false,
      linkDocumentoDescarga: "",
      nombreDocumentoDescarga: "",

    };
  },
  beforeMount() {
    this.obtenerDocumento();
    this.obtenerPeriodos();
  },

  methods: {
    getTrabajadores: function(empresa){

      if(empresa.trabajadoresFiltrados.length > 0){
        this.txtEnviarTodos = "Enviar mail a seleccionados";
      }else{
        this.txtEnviarTodos = "Enviar mail a todos";
      }

      this.isLoadingTrabajadoresFiltros = true;
      var url = cons.port+"://" +
          cons.ipServer + "/get_trabajadores_empresa/" +
          empresa.idEmpresa+
          "/" +
          this.seltipodoc.valor +
          "/" +
          this.mesSelected.valor + "/" + this.periodoSelected.valor;

      if(empresa.rqstTrabs != null){
          empresa.rqstTrabs.cancel()
          empresa.rqstTrabs.msg = "cancelado";
          empresa.rqstTrabs = null;
      }
      const axiosSource = axios.CancelToken.source();
      empresa.rqstTrabs = { cancel: axiosSource.cancel, msg: "Cargando..." };
  
      axios({
      method: "POST",
      url: url,
      cancelToken: axiosSource.token,
      "data": {
          "paginacionTrabajadores": {
              "strFiltro": empresa.strFiltroTrabajadores,
              "actual": empresa.currentPage,
              "tamanioPagina": 10
          }
      },
      headers: {
          Authorization: `${this.tokenLogin}`,
      },
      }).then((result) => {
          empresa.totalPages = Number((result.data.totalTrabajadores/10).toFixed(0))
          
          if(this.trabajadoresFiltro.length == 1 && this.trabajadoresFiltro[0].rutTrabajador == '0'){
              this.trabajadoresFiltro = []
          }


          this.trabajadoresFiltro = this.trabajadoresFiltro.concat(result.data.trabajadores)
          empresa.currentPage++
      },
      (error) => {
        console.log(error)
      }
      )
      .finally(() => {
          this.isLoadingTrabajadoresFiltros = false;
          empresa.rqstTrabs = null;
      });
    },
    getTrabajadoresFiltrados: function(empresa){

      if(empresa.trabajadoresFiltrados.length > 0){
        this.txtEnviarTodos = "Enviar mail a seleccionados";
      }else{
        this.txtEnviarTodos = "Enviar mail a todos";
      }

      this.isLoadingTrabajadoresFiltros = true;
      var url = cons.port+"://" +
          cons.ipServer + "/get_trabajadores_empresa/" +
          empresa.idEmpresa+
          "/" +
          this.seltipodoc.valor +
          "/" +
          this.mesSelected.valor + "/" + this.periodoSelected.valor;

      if(empresa.rqstTrabs != null){
          empresa.rqstTrabs.cancel()
          empresa.rqstTrabs.msg = "cancelado";
          empresa.rqstTrabs = null;
      }
      const axiosSource = axios.CancelToken.source();
      empresa.rqstTrabs = { cancel: axiosSource.cancel, msg: "Cargando..." };
  
      axios({
      method: "POST",
      url: url,
      cancelToken: axiosSource.token,
      "data": {
          "paginacionTrabajadores": {
              "strFiltro": empresa.strFiltroTrabajadores,
              "actual": empresa.currentPage,
              "tamanioPagina": 10
          }
      },
      headers: {
          Authorization: `${this.tokenLogin}`,
      },
      }).then((result) => {
          empresa.totalPages = Number((result.data.totalTrabajadores/10).toFixed(0))

          this.trabajadoresFiltro = result.data.trabajadores
          empresa.currentPage++
      },
      (error) => {
        console.log(error)
      }
      )
      .finally(() => {
          this.isLoadingTrabajadoresFiltros = false;
          empresa.rqstTrabs = null;
      });
    },
    asyncFind: function(query, empresa){//recibe el id,por lo que se seteo el id por la empresa para poder pasar el valor
                
        empresa.strFiltroTrabajadores = query
        empresa.currentPage = 1
        this.trabajadoresFiltro = [{ rutTrabajador: '0', nombreTrabajador: 'Buscando...', documento:{hayDocumento: false},  $isDisabled: true }]
        this.getTrabajadoresFiltrados(empresa)
    },
    filTrab: function(trab, empresa){
        empresa.trabajadoresFiltrados.push(trab)
        empresa.paginacion.current = 1
        this.obtenerTrabajadores(empresa)
    },
    rmvTrabSel: function(trab, empresa){
        for(var indx=0; indx <= empresa.trabajadoresFiltrados.length; indx++){
            if(empresa.trabajadoresFiltrados[indx].rutTrabajador == trab.rutTrabajador){
                empresa.trabajadoresFiltrados.splice(indx, 1)
                break;
            }
        }
        if(this.mesSelected != null && this.periodoSelected != null)
            this.obtenerTrabajadores(empresa)
        
        
    },
    reachedEndOfList(reached, entry, empresa) {
      if(empresa != null)
        if (reached) {
            if(this.hasNextPage(empresa))
              this.getTrabajadores(empresa)
        }
    },
    hasNextPage(empresa) { if(empresa != null) return empresa.currentPage + 1 <=empresa.totalPages },
    customTrabajador: function(trabajador) {
       if(trabajador.rutTrabajador == '0'){
          return 'Buscando...'
        }else {
          return `${trabajador.rutTrabajador} – ${trabajador.nombreTrabajador} ${(!trabajador.documento.hayDocumento)?"(Sin Documento)":""}`
        }
    },
    cambiarCorreoTrabajador: function(trabajador){

        if(trabajador.mailValido){

          trabajador.isModificandoMail = true
          var url = cons.port + "://" + cons.ipServer + "/" + "cambiar_correo_trabajador/" 
            + trabajador.mailModificado + "/" 
            + trabajador.rutTrabajador + "/"
            + this.selempresa.idEmpresa

          axios({
            method: "POST",
            url: url,
            headers: {Authorization: `${this.tokenLogin}`},
          })
          .then((result) => {

              trabajador.modificarMail = false
              trabajador.tieneMailTrabajador = true


              this.$notification.success(
                result.data.mensaje,
                { timer: 10, position: "bottomRight" }
              );
            },
            (error) => {
              this.$notification.error(
                result.data.mensaje,
                { timer: 10, position: "bottomRight" }
              );
            }
          )
          .finally(() => {
            trabajador.isModificandoMail = false
          });

        } else{
          this.$notification.error(
            "Correo Invalido",
            { timer: 5, position: "bottomRight" }
          );
        }

    },
    validarMail: function(trabajador){
        if(trabajador.mailModificado == "" || trabajador.mailModificado == null){
            trabajador.mailValido = false
        } else{
            trabajador.mailValido =  this.regMail.test(trabajador.mailModificado)
        }

    },
    enviaraTodos: function(){
      this.isLoadingEnvioTodos = true
      this.txtEnviarTodos = "enviando"
      var url = cons.port+"://" + cons.ipServer + "/" + "enviar_documento_trabajador/"
      var trabajadores = []
      if(this.trabajadoresSelectedFiltro != null && this.trabajadoresSelectedFiltro.length > 0){
        this.trabajadoresSelectedFiltro.forEach(trabajador => {
          trabajadores.push({"rutTrabajador": trabajador.rutTrabajador})
        });
      }
      axios({
          method: "POST",
          url: url,
          "data": {
            "trabajadoresEnviar": {
              "enviarTodos": true,
              "idEmpresa": this.selempresa.idEmpresa,
              "anioPeriodo": this.periodoSelected.valor,
              "mesPeriodo": this.mesSelected.valor,
              "tipoDoc": this.seltipodoc.valor,
              "trabajadores": trabajadores
            }
          },
          headers: {
            Authorization: `${this.tokenLogin}`,
          },
        })
        .then((result) => {
            this.$notification.success(
              result.data.mensaje,
              { timer: 10, position: "bottomRight" }
            );
          },
          (error) => {
            this.$notification.error(
              result.data.mensaje,
              { timer: 10, position: "bottomRight" }
            );
          }
        )
        .finally(() => {
          this.txtEnviarTodos = "Enviar mail a todos"
          this.isLoadingEnvioTodos = false
          this.obtenerTrabajadores(this.selempresa)
        });
    },
    enviarDocumentoTrabajador: function(trabajador){
      
      trabajador.documento.isLoadiongEnvio = true
      var url = cons.port+"://" + cons.ipServer + "/" + "enviar_documento_trabajador/"
      
      axios({
          method: "POST",
          url: url,
          "data": {
            "trabajadoresEnviar": {
              "enviarTodos": false,
              "idEmpresa": this.selempresa.idEmpresa,
              "anioPeriodo": this.periodoSelected.valor,
              "mesPeriodo": this.mesSelected.valor,
              "tipoDoc": this.seltipodoc.valor,
              "trabajadores":[{"rutTrabajador": trabajador.rutTrabajador}]
            }
          },
          headers: {
            Authorization: `${this.tokenLogin}`,
          },
        })
        .then((result) => {
            this.$notification.success(
              result.data.mensaje,
              { timer: 10, position: "bottomRight" }
            );
          },
          (error) => {
            this.$notification.error(
              result.data.mensaje,
              { timer: 10, position: "bottomRight" }
            );
          }
        )
        .finally(() => {
          trabajador.documento.isLoadiongEnvio = false
          this.obtenerTrabajadores(this.selempresa)
        });
    },
    obtenerEmpresa: function (tipodoc) {
      if (this.periodoSelected != null || this.mesSelected != null) {
        this.isLoadingEmpresas = true;
        var url =
          cons.port+"://" +
          cons.ipServer +
          "/" +
          "get_empresas_documentos/" +
          this.periodoSelected.valor +
          "/" +
          this.mesSelected.valor +
          "/" +
          tipodoc.valor +
          "/REMU";

        if(this.rqstEmps != null){
            this.rqstEmps.cancel()
            this.rqstEmps.msg = "cancelado";
            this.rqstEmps = null;
        }
        const axiosSource = axios.CancelToken.source();
        this.rqstEmps = { cancel: axiosSource.cancel, msg: "Cargando..." };
        axios({
          method: "GET",
          url: url,
          cancelToken: axiosSource.token,
          headers: {
            Authorization: `${this.tokenLogin}`,
          },
        })
          .then(
            (result) => {
              this.empresas = result.data.empresas;
              var BreakException = {};

              if(this.selempresa != null){
                try{
                  result.data.empresas.forEach(empresa => {
                    if(empresa.idEmpresa == this.selempresa.idEmpresa){

                      this.selempresa = empresa
                      this.paginacion = this.selempresa.paginacion
                      throw BreakException
                    }
                  })
                } catch (e) {
                  if (e !== BreakException) throw e;
                }
                this.obtenerTrabajadores(this.selempresa);
              } else{

                if (this.selectPeriodoActual) {
                  this.selempresa = this.empresas[0];
                  this.paginacion = this.selempresa.paginacion
                  this.obtenerTrabajadores(this.selempresa);
                }
              }



              /*if (this.selectPeriodoActual) {
                console.log("entro1")
                
                if(this.selempresa != null){
                  console.log("entro2")
                   result.data.empresas.forEach(empresa => {if(empresa.idEmpresa==this.selempresa.idEmpresa){
                     console.log("entro5")
                    this.selempresa = empresa
                    this.paginacion = this.selempresa.paginacion
                  }})
                } else{
                  console.log("entro4")
                  this.selempresa = this.empresas[0];
                  this.paginacion = this.selempresa.paginacion
                }
                console.log("empresa", this.selempresa)
                this.obtenerTrabajadores(this.selempresa);
              } else{
                console.log("entro6")
                this.selempresa = this.empresas[0];
                this.paginacion = this.selempresa.paginacion
                this.obtenerTrabajadores(this.selempresa);
              }*/
             

            },
            (error) => {}
          )
          .finally(() => {
            this.selectPeriodoActual = false;
            this.isLoadingEmpresas = false;
            this.rqstEmp = null
          });
      }
    },

    obtenerDocumento: function () {
      var url = cons.port+"://" + cons.ipServer + "/get_tipo_documentos";
      axios({
        method: "GET",
        url: url,
        headers: {
          Authorization: `${this.tokenLogin}`,
        },
      })
        .then(
          (result) => {
            this.tipodoc = result.data;
            if (this.tipodoc.length == 1) {
              this.seltipodoc = this.tipodoc[0];
              this.obtenerEmpresa(this.seltipodoc)
            }
          },
          (error) => {}
        )
        .finally(() => {});
    },
    handleTableChange: function(pagination, filters, sorter, filasActuales){
        pagination.empresa.paginacion = pagination
        this.paginacion = pagination
        /*console.log("emp", pagination.empresa)
        console.log("pagination", pagination);
        console.log("filters", filters)
        console.log("sorter", sorter)
        console.log("filasActuales", filasActuales)*/
        //pagination.empresa.paginacion = pagination
        this.obtenerTrabajadores(pagination.empresa)

    },

    obtenerTrabajadores: function (selempresa) {
      this.getTrabajadores(selempresa)
      this.selempresa = selempresa;
      this.isLoadingTrabajadores = true;
      this.estadosDocumentos = []
      var url = cons.port+"://" +
        cons.ipServer +
        "/get_trabajadores_empresa/" +
        this.selempresa.idEmpresa +
        "/" +
        this.seltipodoc.valor +
        "/" +
        this.mesSelected.valor +
        "/" +
        this.periodoSelected.valor;

      axios({
        method: "POST",
        url: url,
        "data": {
            "paginacionTrabajadores": {
                "actual": selempresa.paginacion.current,
                "tamanioPagina": selempresa.paginacion.pageSize,
                "filtrosTrabajadores": selempresa.trabajadoresFiltrados
            }
        },
        headers: {
          Authorization: `${this.tokenLogin}`,
        },
      })
        .then(
          (result) => {
            this.selempresa.hayTrabajadoresParaEnviar = result.data.hayTrabajadoresParaEnviar
            
            if(result.data.totalDocumentosTrab >0){
                this.selempresa.hayDocumentosTrabajador = true
            }

            this.trabajadores = result.data.trabajadores;
            
            if(this.selempresa.totalTrabajadoresDocumentos >0){
                  this.selempresa.hayDocumentosTrabajador = true
              }

            const pagination = { ...this.paginacion };
            pagination.total = result.data.totalTrabajadores
            pagination.empresa = this.selempresa
            this.paginacion = pagination
            this.selempresa.paginacion = pagination
            /*this.trabajadores.forEach(trab =>{
                if(trab.documento.hayDocumento){
                    this.selempresa.hayDocumentosTrabajador = true
                }
            })*/
          },
          (error) => {}
        )
        .finally(() => {
          this.isLoadingTrabajadores = false;
          this.validarestado();
          this.visualbotones();
        });
    },

    customNamePeriodo(periodo) {
      return `${periodo.nombrePeriodo}`;
    },

    nomcod(empresa) {
      return `(${empresa.codEmpresa}) ${empresa.nombreEmpresa}`;
    },

    obtenerPeriodos: function () {
      var url = cons.port+"://" + cons.ipServer + "/get_periodos/";

      axios({
        method: "GET",
        url: url,
        headers: {
          Authorization: `${this.tokenLogin}`,
        },
      })
        .then(
          (result) => {
            this.periodos = result.data;
            if(this.periodos.length == 1){

            }
          },
          (error) => {}
        )
        .finally(() => {});
    },

    check: function (evt) {
      if (this.message.length >= this.limit) {
        if (evt.keyCode >= 48 && evt.keyCode <= 90) {
          evt.preventDefault();
          return;
        }
      }
    },

    closeModalDescarga: function(){
      this.generadoDocumentoDescarga = false
      this.linkDocumentoDescarga = ""
      this.nombreDocumentoDescarga = ""
      this.auxi = ""
    },

    onClick() {
      this.isdownload = true;
      this.auxi = "Estamos Generando el archivo, espere por favor...";
      //this.auxi = "Generando Enlace de Descarga";
      var trabajadores = []
      if(this.trabajadoresSelectedFiltro != null && this.trabajadoresSelectedFiltro.length > 0){
        this.trabajadoresSelectedFiltro.forEach(trabajador => {
          trabajadores.push({"rutTrabajador": trabajador.rutTrabajador})
        });
      }

      axios({
        url:
          cons.port+"://" +
          cons.ipServer +
          "/descargar_documentos/" +
          this.picked +
          "/" +
          this.selempresa.codEmpresa +
          "/" +
          this.seltipodoc.valor +
          "/" +
          this.selempresa.idEmpresa +
          "/REMU/" +
          this.mesSelected.valor +
          "/" +
          this.periodoSelected.valor,
        method: "GET",
        data: { 
          "infoTrabajadores": {
            "trabajadoresSelected": [],
            "trabajadores": trabajadores
          }
        },
        headers: {
          Authorization: `${this.tokenLogin}`,
        },
      })
        .then(
          (response) => {
            
            this.generadoDocumentoDescarga = true
            this.linkDocumentoDescarga = response.data.link
            this.nombreDocumentoDescarga = response.data.nombre

            this.auxi = "Generando link de descarga un mnomento...";
            /*const link = document.createElement("a");
            link.href = response.data.link;
            link.download = response.data.nombre;
            link.setAttribute('target', '_blank')*/
            var elemento = document.getElementById("documentoDescarga");
            elemento.setAttribute('href', response.data.link)
            elemento.click()

            this.auxi = "Pronto Comenzará su Descarga";
            //link.click()
            

            /*link.dispatchEvent(
                new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                })
            );*/

            if (this.picked == "merge")  {
              this.$notification.success(
                "La Descarga del SuperDocumento comenzará pronto...",
                { timer: 10, position: "bottomRight" }
              );
            } else {
              this.$notification.success(
                "La Descarga de Archivos Comprimidos comenzará pronto...",
                { timer: 10, position: "bottomRight" }
              );
            }
            /*var x = 1;
            this.auxi = "Generando link de descarga un mnomento...";

            var fileLink = document.createElement("a");
            fileLink.href = response.data.link;

            if (this.picked == "merge") {
              fileLink.setAttribute("download", response.data.nombre);
              x = 0;
            }
            if (this.picked == "zip") {
              fileLink.setAttribute("download", response.data.nombre);
              x = 1;
            }
            fileLink.setAttribute('target', '_blank');
            document.body.appendChild(fileLink);
            this.auxi = "Pronto Comenzara su Descarga";
            fileLink.click();
            document.body.removeChild(fileLink);

            if (x == 0) {
              this.$notification.success(
                "La Descarga del SuperDocumento comenzará pronto...",
                { timer: 10, position: "bottomRight" }
              );
            } else {
              this.$notification.success(
                "La Descarga de Archivos Comprimidos comenzará pronto...",
                { timer: 10, position: "bottomRight" }
              );
            }
            this.isdownload = false;
            */
          },
          (error) => {
            this.$notification.error("Ha ocurrido un error en la descarga", {
              timer: 10,
              position: "bottomRight",
            });
          }
        )
        .finally(() => {
          this.isdownload = false;
          //this.tripleDialog = false;
        });
    },

    refreshmes: function (mesSelected) {

      this.mesSelected = mesSelected
      //if(this.selempresa == null){
      this.obtenerEmpresa(this.seltipodoc);
      //}

      /*if (
        mesSelected != null &&
        this.periodoSelected != null &&
        this.seltipodoc != null &&
        this.selempresa != null
      ) {
        console.log("6")
          this.obtenerTrabajadores(this.selempresa);
      }*/
    },

    refreshperiodo: function (periodoSelected) {

      this.periodoSelected = periodoSelected
      //if(this.selempresa == null){
      this.obtenerEmpresa(this.seltipodoc);
      //}
      /*if (
        this.mesSelected != null &&
        periodoSelected != null &&
        this.seltipodoc != null &&
        this.selempresa != null
      ) {
          this.obtenerTrabajadores(this.selempresa);
      }*/
    },

    aceptar: function () {
      axios({
        url:
          cons.port+"://" +
          cons.ipServer +
          "/" +
          "aceptar_documentos/" +
          this.selempresa.idEmpresa +
          "/" +
          this.mesSelected.valor +
          "/" +
          this.periodoSelected.valor +
          "/" +
          this.seltipodoc.valor,
        method: "POST",
        headers: {
          Authorization: `${this.tokenLogin}`,
        },
      })
        .then(
          (result) => {
            this.selempresa.estado = result.data.estadoEmpresa;
            this.$notification.success(
              "La empresa ha sido Aceptada con exito",
              { timer: 10, position: "bottomRight" }
            );
          },
          (error) => {
            
            this.$notification.error(
              error.response.data.mensaje,
              { timer: 10, position: "bottomRight" }
            );
            /*if (error.response.data) {

              if (this.selempresa.estado == 0 || this.selempresa.estado == 1) {
                if (this.selempresa.estado == 0) {
                  this.$notification.error(
                    "La Empresa se encuentra SIN REVISAR",
                    { timer: 10, position: "bottomRight" }
                  );
                } else {
                  this.$notification.error(
                    "La Empresa se encuentra EN REVISIÓN",
                    { timer: 10, position: "bottomRight" }
                  );
                }
              } else if (this.selempresa.estado == 2) {
                this.$notification.error("La Empresa se encuentra RECHAZADA", {
                  timer: 10,
                  position: "bottomRight",
                });
              } else {
                this.$notification.error("La Empresa se encuentra ACEPTADA", {
                  timer: 10,
                  position: "bottomRight",
                });
              }
            }*/
          }
        )
        .finally(() => {
          this.validarestado();
        });
    },

    validarestado: function () {
      if (this.selempresa.estado == 0) {
        this.estado = "Sin Revisar";
        this.visualbotones();
      }
      if (this.selempresa.estado == 1) {
        this.estado = "En Revisión";
        this.visualbotones();
      }
      if (this.selempresa.estado == 2) {
        this.estado = "Rechazada";
        this.visualbotones();
      }
      if (this.selempresa.estado == 3) {
        this.estado = "Aceptada";
        this.visualbotones();
      }
    },
    rechazar: function () {
      const datos = {
        mensajeRechazo: this.message,
        documentosRechazados: this.estadosDocumentos,
      };

      axios({
        url:
          cons.port+"://" +
          cons.ipServer +
          "/" +
          "rechazar_documentos/" +
          this.selempresa.idEmpresa +
          "/" +
          this.mesSelected.valor +
          "/" +
          this.periodoSelected.valor +
          "/" +
          this.seltipodoc.valor,
        method: "POST",
        data: { datosRechazo: datos },
        headers: {
          Authorization: `${this.tokenLogin}`,
        },
      })
        .then(
          (result) => {
            this.selempresa.estado = result.data.estadoEmpresa;
            this.$notification.success(
              "La Empresa ha sido Rechazada con exito",
              { timer: 10, position: "bottomRight" }
            );
          },
          (error) => {
            this.$notification.error(
              error.response.data.mensaje,
              { timer: 10, position: "bottomRight" }
            );
            /*if (error.response) {
              if (this.selempresa.estado == 0 || this.selempresa.estado == 1) {
                if (this.selempresa.estado == 0) {
                  this.$notification.error(
                    "La Empresa se encuentra SIN REVISAR",
                    { timer: 10, position: "bottomRight" }
                  );
                } else {
                  this.$notification.error(
                    "La Empresa se encuentra EN REVISIÓN",
                    { timer: 10, position: "bottomRight" }
                  );
                }
              } else if (this.selempresa.estado == 2) {
                this.$notification.error("La Empresa se encuentra RECHAZADA", {
                  timer: 10,
                  position: "bottomRight",
                });
              } else {
                this.$notification.error("La Empresa se encuentra ACEPTADA", {
                  timer: 10,
                  position: "bottomRight",
                });
              }
            }*/
          }
        )
        .finally(() => {
          this.validarestado();
        });
    },
    visualbotones: function () {
      if (
        this.estado == "Sin Revisar" ||
        this.estado == "Rechazada" ||
        this.estado == "Aceptada"
      ) {
        this.visboton = 1;
      } else {
        this.visboton = 0;
      }
    },

    marcdes: function (marcado) {
      if (marcado == true) {
        for (var trabajador in this.trabajadores) {
          this.trabajadores[trabajador].chek = true;
        }
      } else {
        for (var trabajador in this.trabajadores) {
          this.trabajadores[trabajador].chek = false;
        }
      }
    },

    ultimoperiodo: function () {
      var anioActual = new Date().getFullYear()
      var mesActual = new Date().getMonth()//se obtiene el anterior

      if(this.selectPeriodoActual){
          for(var periodo in this.periodos){
              if(this.periodos[periodo].valor == anioActual){
                  this.periodoSelected = this.periodos[periodo]
                  var mesEncontrado = false

                  for(var mes in this.periodoSelected.meses){
                      if(this.periodoSelected.meses[mes].valor == mesActual){
                          this.mesSelected = this.periodoSelected.meses[mes]
                          mesEncontrado = true
                          break
                      }
                  }
                  if(mesEncontrado)
                      break
              }
          }
          this.seltipodoc = this.tipodoc[0]
          //console.log(this.periodoSelected, this.mesSelected, this.tipoDocumentoSelected)
          this.obtenerEmpresa(this.seltipodoc)
      }
      /*if (this.selectPeriodoActual) {
        for (var periodo in this.periodos) {
          if (this.periodos[periodo].valor == new Date().getFullYear()) {
            this.periodoSelected = this.periodos[periodo];

            var mesEncontrado = false;

            for (var mes in this.periodoSelected.meses) {
              if (
                this.periodoSelected.meses[mes].valor == new Date().getMonth()
              ) {
                this.mesSelected = this.periodoSelected.meses[mes];
                mesEncontrado = true;
                this.primerdisp();
                break;
              }
            }
            if (mesEncontrado) {
              this.primerdisp();
              break;
            }
          }
        }
      }*/
    },
    formatFechaDocumento: function (fechaDoc) {
      //return format(new Date(fechaDoc), 'EEE d LLL/yy H:mm:ss', {locale: es})//'dd/MM/yyyy' 'EEE d LLL/yy H:mm:ss'
      
      if(fechaDoc != null){
        return formatDistance(new Date(fechaDoc), new Date(), {
          addSuffix: true,
          locale: es,
        }); //.isSame(moment().clone().startOf('day'), 'd')
      }
      else{
        return "Nunca"
      }
      
    },

    abrirVisor: function (trabajador) {
      this.prevue = true;
      this.trabajadorprev = trabajador;
    },

    primerdisp: function () {
      this.obtenerDocumento();
      //this.seltipodoc = this.tipodoc[0];
      //this.obtenerEmpresa(this.seltipodoc);
    },
  },
};
</script>

<style scoped>
.form-group{
  margin-top: 1rem;
  margin-bottom: 0;
}
.form-row{
  width: 80%;
}
</style>